var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "event-modal",
      class: {
        "v--modal-box v--modal": _vm.isChangeOrder,
        "modal-delete": _vm.isDeleteModal
      },
      attrs: { name: "modalInfo", height: _vm.calculateHeight, width: 700 },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c("div", { staticClass: "modal-header-text" }, [
          _c("span", [_vm._v(_vm._s(_vm.modalData.title))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [
          _vm.showModalBody
            ? _c("ModalInfoBody", { attrs: { messages: _vm.bodyMessage } })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-footer" },
        [
          _vm.modalData.btnLeft != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-left ap-btn secondary",
                  on: {
                    click: function($event) {
                      _vm.hideModal()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnLeft) + "\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modalData.btnRight != ""
            ? _c(
                "b-button",
                {
                  staticClass: "modal-btn-right ap-btn primary",
                  on: {
                    click: function($event) {
                      _vm.btnAction()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.modalData.btnRight) + "\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05e88dc2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e88dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalInfo.vue
// module id = 1530
// module chunks = 1